/* Chakki Peesing — mobile bottom nav + app mode (loaded by sections/mobile-bottom-nav.liquid) */
(function () {
  function cpInit() {
  (function () {
    var nav = document.getElementById('cpbn');
    if (!nav || nav.dataset.ready) return;
    nav.dataset.ready = '1';
    var design = !!(window.Shopify && window.Shopify.designMode); /* true inside the theme editor */
    /* true when opened from the home screen icon */
    var isApp = (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || window.navigator.standalone === true;

    /* App launch = opened fresh from the home screen icon (also after the app was fully closed).
       Not a launch: reload, back/forward, or moving between pages inside the app. */
    var cpLaunch = (function () {
      if (!isApp || design) return false;
      if (/\/(account|challenge|checkouts?|orders)(\/|$)/.test(location.pathname)) return false;
      var fresh = false; /* first page of this app session */
      try { fresh = !sessionStorage.getItem('cp_live'); sessionStorage.setItem('cp_live', '1'); } catch (err) {}
      var t = 'navigate';
      try {
        var ne = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
        if (ne) t = ne.type; else if (performance.navigation && performance.navigation.type === 1) t = 'reload';
      } catch (err) {}
      if (t === 'reload' || t === 'back_forward') return false;
      return fresh || !document.referrer || /[?&]utm_source=homescreen/.test(location.search);
    })();
    /* A welcome screen is enabled → every launch starts on the homepage (no resume) */
    var cpWelcomeOn = !!document.getElementById('cpdaily') || !!document.querySelector('#cpfest[data-intro="true"]');

    /* 16a) Resume: reopened from the icon within N minutes → go back to the last page */
    var APP_KEY = 'cp_app_last'; /* separate name: RKEY is used later for recent searches */
    var cfgR = document.getElementById('cpappcfg');
    var resumeMin = cfgR ? (parseInt(cfgR.dataset.resume || '0', 10) || 0) : 0;
    var path0 = location.pathname;
    if (isApp && resumeMin > 0 && !design && !cpWelcomeOn) {
      var started = null;
      try { started = sessionStorage.getItem('cp_app_started'); sessionStorage.setItem('cp_app_started', '1'); } catch (err) {}
      if (!started && (path0 === '/' || /utm_source=homescreen/.test(location.search))) {
        var last = null;
        try { last = JSON.parse(localStorage.getItem(APP_KEY) || 'null'); } catch (err) {}
        if (last && last.u && last.u !== '/' && Date.now() - last.t < resumeMin * 60000 &&
          last.u.indexOf('/account/logout') === -1 && last.u.indexOf('/checkouts') === -1) {
        location.replace(last.u);
        return;
        }
      }
      var save = function () {
        var u = location.pathname + location.search.replace(/[?&]utm_[^&]*/g, '').replace(/^&/, '?');
        if (/\/account\/login|\/challenge|\/checkouts?\/|\/thank_you|\/orders\//.test(u)) return; /* never reopen login / checkout pages */
        try { localStorage.setItem(APP_KEY, JSON.stringify({ u: u, t: Date.now() })); } catch (err) {}
      };
      window.addEventListener('pagehide', save);
      document.addEventListener('visibilitychange', function () { if (document.hidden) save(); });
    }


    /* Theme editor re-renders this section on every change: remove the old search bar / chips
       that were moved out of the previous copy, so nothing is duplicated */
    var sec = nav.closest('.shopify-section');
    if (sec) {
      document.querySelectorAll('#cpsb, #cpss').forEach(function (el) { if (!sec.contains(el)) el.remove(); });
    }
    var mq = window.matchMedia('(max-width: 749px)');


    /* ===== Shared helpers ===== */
    function cpPost(items) {
      return fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });
    }
    function cpItems(raw) {
      return (raw || []).map(function (it) {
        var o = { id: it.id, quantity: it.quantity };
        if (it.props && it.props.length) {
          o.properties = {};
          it.props.forEach(function (kv) { o.properties[kv[0]] = kv[1]; });
        }
        return o;
      });
    }
    function cpOpenCart() {
      var h = document.getElementById('cart-icon-bubble');
      if (h) h.click(); else window.location.href = '/cart';
    }
    function cpLs(k, v) {
      try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (err) { return null; }
    }

    /* 7) Home tab: already on the homepage → scroll to top instead of reloading */
    nav.querySelectorAll('[data-cpbn="home"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (location.pathname === '/' || location.pathname === (window.Shopify && Shopify.routes && Shopify.routes.root) ) {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });
    });

    /* 8) NEW badge on the Shop tab — hides once the customer has tapped Shop */
    nav.querySelectorAll('.cpbn__badge').forEach(function (b) {
      var key = 'cp_badge_seen';
      if (cpLs(key) !== b.dataset.badge) b.hidden = false;
      var link = b.closest('a');
      if (link) link.addEventListener('click', function () { cpLs(key, b.dataset.badge); });
    });

    /* 9) "Your mix" chip — re-add the customer's last MYOM recipe in one tap */
    var mix = document.getElementById('cpbn-mix');
    var mixW = document.getElementById('cpbn-mixw');
    var MIX_KEY = 'cp_mix_hidden_until';
    var mixHiddenUntil = parseInt(cpLs(MIX_KEY) || '0', 10) || 0;
    var mixSeen = null;
    try { mixSeen = sessionStorage.getItem('cp_mix_seen'); } catch (err) {}
    /* homepage only, once per visit; ✕ hides it for 7 days */
    if (mix && mixW && !design && location.pathname === '/' && !mixSeen && nav.querySelector('[data-cpbn="myom"]') && Date.now() > mixHiddenUntil) {
      mixW.hidden = false;
      try { sessionStorage.setItem('cp_mix_seen', '1'); } catch (err) {}
      var mixDone = false;
      var hideMix = function (remember) {
        mixW.classList.add('is-out');
        setTimeout(function () { mixW.hidden = true; }, 320);
        if (remember) cpLs(MIX_KEY, String(Date.now() + 7 * 86400000)); /* ✕ → hide for 7 days */
      };
      mixW.querySelector('.cpbn__mix-x').addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation(); hideMix(true);
      });
      /* auto-hide after N seconds (0 = keep it) */
      var mixSecs = parseInt(mixW.dataset.autohide || '0', 10) || 0;
      var mixTimer = mixSecs ? setTimeout(function () { if (!mixDone) hideMix(false); }, mixSecs * 1000) : null;
      var mixText = mix.querySelector('.cpbn__mix-text');
      mix.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (mixDone) { cpOpenCart(); return; }
        var items = [];
        try { items = cpItems(JSON.parse(mix.querySelector('.cpbn__mix-data').textContent)); } catch (err) {}
        if (!items.length) return;
        if (mixTimer) clearTimeout(mixTimer);
        mix.disabled = true;
        mixText.textContent = 'Adding…';
        cpPost(items).then(function () {
          mixDone = true;
          mix.disabled = false;
          mix.classList.add('is-done');
          mixText.textContent = 'Added ✓ View cart';
          if (window.gtag) { try { gtag('event', 'reorder_mix'); } catch (err) {} }
          if (window.fbq) { try { fbq('trackCustom', 'ReorderMix'); } catch (err) {} }
          setTimeout(cpOpenCart, 700);
          setTimeout(function () { hideMix(false); }, 4000);
        }).catch(function () {
          mix.disabled = false;
          mixText.textContent = 'Try again';
        });
      });
    }

    /* 10) Recently viewed — save on product pages, show in the search popup */
    var RV_KEY = 'cp_recently_viewed';
    var rvCur = null;
    try { var rvEl = document.getElementById('cprv-current'); if (rvEl) rvCur = JSON.parse(rvEl.textContent); } catch (err) {}
    if (rvCur && rvCur.h) {
      var rvList = [];
      try { rvList = JSON.parse(cpLs(RV_KEY) || '[]') || []; } catch (err) {}
      rvList = rvList.filter(function (x) { return x && x.h !== rvCur.h; });
      rvList.unshift(rvCur);
      cpLs(RV_KEY, JSON.stringify(rvList.slice(0, 8)));
    }
    window.__cpRenderViewed = function (panel) {
      var grp = panel && panel.querySelector('.cpss__group--viewed');
      if (!grp) return;
      var list = [];
      try { list = JSON.parse(cpLs(RV_KEY) || '[]') || []; } catch (err) {}
      list = list.filter(function (x) { return x && x.u && (!rvCur || x.h !== rvCur.h); }).slice(0, 4);
      var box = grp.querySelector('.cpss__viewed');
      box.innerHTML = '';
      list.forEach(function (x) {
        var a = document.createElement('a');
        a.className = 'cpss__rv';
        a.href = x.u;
        if (x.i) { var im = document.createElement('img'); im.src = x.i; im.alt = ''; im.loading = 'lazy'; im.width = 84; im.height = 84; a.appendChild(im); }
        var t = document.createElement('span'); t.className = 'cpss__rv-t'; t.textContent = x.t || ''; a.appendChild(t);
        if (x.p) { var pr = document.createElement('span'); pr.className = 'cpss__rv-p'; pr.textContent = x.p; a.appendChild(pr); }
        box.appendChild(a);
      });
      grp.hidden = !list.length;
    };

    /* 11) WhatsApp help on the search results page
       - no results  → big box at the top, right under the search header
       - has results → slim line AFTER the product grid, so products stay at the top */
    var waBox = document.getElementById('cpwa-search');
    if (waBox) {
      var waLink = waBox.querySelector('.cpwa__btn');
      if (waLink) waLink.addEventListener('click', function () { if (window.gtag) { try { gtag('event', 'whatsapp_help_click', { from: 'search_page' }); } catch (err) {} } });
      var isEmpty = waBox.classList.contains('cpwa--empty');
      var grid = document.getElementById('ProductGridContainer') || document.querySelector('.template-search__results') || document.getElementById('product-grid');
      var head = document.querySelector('.template-search__header');
      if (!isEmpty && grid && grid.parentNode) {
        grid.parentNode.insertBefore(waBox, grid.nextSibling);
      } else if (head && head.parentNode) {
        head.parentNode.insertBefore(waBox, head.nextSibling);
      } else {
        var mc = document.querySelector('#MainContent > *');
        if (mc && mc.parentNode) mc.parentNode.insertBefore(waBox, mc.nextSibling);
      }
    }


    /* 20) Back in stock — show "Notify me on WhatsApp" when the selected variant is sold out */
    var bis = document.getElementById('cpbis');
    if (bis && !design) {
      var bisVariants = [];
      try { bisVariants = JSON.parse(bis.querySelector('.cpbis__variants').textContent) || []; } catch (err) {}
      var vmap = {};
      bisVariants.forEach(function (v) { vmap[String(v[0])] = { ok: v[1], title: v[2] }; });
      var pform = document.querySelector('main form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      var idInput = pform && pform.querySelector('[name="id"]');
      var addBtn = pform && (pform.querySelector('[name="add"]') || pform.querySelector('[type="submit"]'));
      /* place our button right under the theme's Add to cart button */
      if (pform) {
        var anchor = (addBtn && addBtn.parentNode) || pform;
        anchor.parentNode.insertBefore(bis, anchor.nextSibling);
      }
      var BIS_KEY = 'cp_bis_done';
      var doneMap = {};
      try { doneMap = JSON.parse(localStorage.getItem(BIS_KEY) || '{}') || {}; } catch (err) {}
      var bisBtn = bis.querySelector('.cpbis__btn');
      var bisDone = bis.querySelector('.cpbis__done');
      var curVid = null;
      var currentVid = function () {
        var vid = idInput && idInput.value;
        if (!vid) { try { vid = new URLSearchParams(location.search).get('variant'); } catch (err) {} }
        if (!vid && bisVariants.length) vid = String(bisVariants[0][0]);
        return vid ? String(vid) : null;
      };
      var refresh = function () {
        var vid = currentVid();
        if (vid === curVid && bis.dataset.ready) return;
        curVid = vid; bis.dataset.ready = '1';
        var v = vid && vmap[vid];
        var soldOut = v ? !v.ok : (addBtn && addBtn.disabled);
        if (!soldOut) { bis.hidden = true; return; }
        bis.hidden = false;
        if (doneMap[vid]) {
          bisBtn.hidden = true; bisDone.hidden = false;
          bisDone.textContent = '✓ You\'re on the list — we\'ll WhatsApp you when it\'s back.';
        } else { bisBtn.hidden = false; bisDone.hidden = true; }
      };
      refresh();
      setInterval(refresh, 700); /* themes change the variant without telling us */

      var sheet = document.getElementById('cpbis-sheet');
      var phoneIn = sheet.querySelector('input[type="tel"]');
      var nameIn = sheet.querySelector('.cpbis-sheet__name');
      var okIn = sheet.querySelector('.cpbis-sheet__ok input');
      var errP = sheet.querySelector('.cpbis-sheet__err');
      var goBtn = sheet.querySelector('.cpbis-sheet__go');
      document.body.appendChild(sheet);
      phoneIn.value = (bis.dataset.phone || '').replace(/\D/g, '').slice(-10);
      nameIn.value = bis.dataset.name || '';
      var openSheet = function () {
        var v = vmap[curVid];
        sheet.querySelector('.cpbis-sheet__prod').textContent = bis.dataset.title + (v && v.title && v.title !== 'Default Title' ? ' (' + v.title + ')' : '');
        errP.hidden = true;
        sheet.hidden = false;
        setTimeout(function () { if (!phoneIn.value) phoneIn.focus(); }, 250);
        if (window.gtag) { try { gtag('event', 'back_in_stock_open', { product: bis.dataset.handle }); } catch (err) {} }
      };
      var closeSheet = function () { sheet.hidden = true; };
      bisBtn.addEventListener('click', function (e) { e.preventDefault(); openSheet(); });
      sheet.querySelector('.cpbis-sheet__x').addEventListener('click', closeSheet);
      sheet.addEventListener('click', function (e) { if (e.target === sheet) closeSheet(); });
      phoneIn.addEventListener('input', function () { phoneIn.value = phoneIn.value.replace(/\D/g, '').slice(0, 10); });

      sheet.querySelector('form').addEventListener('submit', function (e) {
        e.preventDefault();
        var ph = phoneIn.value.replace(/\D/g, '');
        if (!/^[6-9]\d{9}$/.test(ph)) { errP.textContent = 'Please enter a valid 10-digit mobile number.'; errP.hidden = false; return; }
        if (!okIn.checked) { errP.textContent = 'Please tick the box so we can WhatsApp you.'; errP.hidden = false; return; }
        var v = vmap[curVid] || {};
        var data = new URLSearchParams({
          phone: ph, country_code: '+91', name: (nameIn.value || '').trim(),
          product_id: bis.dataset.pid, product_title: bis.dataset.title, product_handle: bis.dataset.handle,
          variant_id: curVid || '', variant_title: v.title || '',
          product_url: location.origin + '/products/' + bis.dataset.handle + (curVid ? '?variant=' + curVid : ''),
          requested_at: new Date().toISOString(), source: isApp ? 'app' : 'web'
        });
        goBtn.disabled = true; goBtn.textContent = 'Saving…';
        /* simple form POST (no preflight) to the Make.com webhook */
        fetch(bis.dataset.hook, { method: 'POST', mode: 'no-cors', body: data })
          .then(function () {
            doneMap[curVid] = Date.now();
            try { localStorage.setItem(BIS_KEY, JSON.stringify(doneMap)); } catch (err) {}
            if (window.gtag) { try { gtag('event', 'back_in_stock_request', { product: bis.dataset.handle, variant: curVid }); } catch (err) {} }
            if (window.fbq) { try { fbq('trackCustom', 'BackInStockRequest', { product: bis.dataset.handle }); } catch (err) {} }
            closeSheet();
            bis.dataset.ready = ''; curVid = null; refresh();
          })
          .catch(function () { errP.textContent = 'Could not save right now. Please try again.'; errP.hidden = false; })
          .then(function () { goBtn.disabled = false; goBtn.textContent = 'Notify me'; });
      });
    }

    /* 13) Order tracking chip + green dot on the Account tab */
    var trk = document.getElementById('cptrack');
    if (trk && !design) {
      var dot = nav.querySelector('[data-cpbn="account"] .cpbn__dot');
      if (dot) dot.hidden = false;
      var TK = 'cp_track_dismissed';
      if (cpLs(TK) !== trk.dataset.key) trk.hidden = false;
      trk.querySelector('.cptrack__x').addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        cpLs(TK, trk.dataset.key);
        trk.hidden = true;
      });
      trk.querySelector('.cptrack__link').addEventListener('click', function () {
        if (window.gtag) { try { gtag('event', 'track_chip_click', { state: trk.dataset.state }); } catch (err) {} }
      });
    }

    /* 12) Festival mode — Navratri, Dussehra, Diwali, Chhath (dates from the Customizer calendar) */
    (function () {
      var fe = document.getElementById('cpfest');
      if (!fe) return;
      var force = fe.dataset.force || 'auto';
      if (force === 'off') return;
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function ymd(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
      var now = new Date();
      var today = ymd(now);
      var fest = null, start = null;
      if (force !== 'auto') {
        fest = force; start = today;
      } else {
        (fe.dataset.cal || '').split(/<br\s*\/?>|\n/i).forEach(function (line) {
          var p = line.trim().split('|').map(function (x) { return x.trim(); });
          if (fest || p.length < 2 || !p[0]) return;
          var s = p[1], e = p[2] || p[1];
          if (today >= s && today <= e) { fest = p[0].toLowerCase(); start = s; }
        });
      }
      if (!fest) return;
      var body = document.body;
      body.classList.add('cpfest', 'cpfest--' + fest);
      var feature = nav.querySelector('.cpbn__item--feature .cpbn__icon');

      if (fest === 'navratri') {
        /* Day colours: days 1–7 follow the weekday, day 8 purple, day 9 peacock green */
        var byWeekday = [['#f57c00', 'Orange'], ['#ffffff', 'White'], ['#d32f2f', 'Red'], ['#1e4fd8', 'Royal Blue'], ['#f9c80e', 'Yellow'], ['#2e9e48', 'Green'], ['#8e8e8e', 'Grey']];
        var sd = new Date(start + 'T00:00:00');
        var dayIdx = Math.max(0, Math.round((new Date(today + 'T00:00:00') - sd) / 86400000));
        var c = dayIdx < 7 ? byWeekday[now.getDay()] : (dayIdx === 7 ? ['#7b3fa0', 'Purple'] : ['#00897b', 'Peacock Green']);
        nav.style.setProperty('--cpfest-c', c[0]);
        if (c[0] === '#ffffff') body.classList.add('cpfest--light');
        if (feature) feature.setAttribute('title', 'Navratri Day ' + (dayIdx + 1) + ' · ' + c[1]);
        addChip(fe.dataset.vrat, 'Vrat Special');
      }

      if (fest === 'diwali') {
        if (feature) {
          var diya = document.createElement('span');
          diya.className = 'cpfest__diya';
          diya.innerHTML = '<svg viewBox="0 0 26 26" aria-hidden="true"><path class="flame" d="M13 3c2.6 3 3.4 5.2 3.4 6.7A3.4 3.4 0 0 1 13 13a3.4 3.4 0 0 1-3.4-3.3C9.6 8.2 10.4 6 13 3z" fill="#ffb300"/><path d="M13 7.5c1 1.3 1.4 2.3 1.4 3a1.4 1.4 0 0 1-2.8 0c0-.7.4-1.7 1.4-3z" fill="#fff3c4"/><path d="M3 14h20c-.8 4.6-4.9 8-10 8S3.8 18.6 3 14z" fill="#c4622d"/><path d="M3 14h20" stroke="#8a3b12" stroke-width="1.6" stroke-linecap="round"/></svg>';
          feature.appendChild(diya);
        }
        var shop = nav.querySelector('[data-cpbn="shop"]');
        if (shop && fe.dataset.gift) {
          shop.href = fe.dataset.gift;
          shop.classList.add('is-gift');
          var lbl = shop.querySelector('.cpbn__label');
          if (lbl) lbl.textContent = fe.dataset.giftLabel || 'Gifts';
          var svg = shop.querySelector('.cpbn__icon svg');
          if (svg) svg.innerHTML = '<rect x="3.5" y="9" width="17" height="11.5" rx="1.5"/><path d="M2.5 9h19V6.5h-19z"/><path d="M12 6.5v14"/><path d="M12 6.5c-1.5-3.5-5.5-3.5-5.5-1 0 1.4 2.5 1 5.5 1zM12 6.5c1.5-3.5 5.5-3.5 5.5-1 0 1.4-2.5 1-5.5 1z"/>';
          var badge = shop.querySelector('.cpbn__badge');
          if (badge) badge.hidden = true;
          shop.addEventListener('click', function () { if (window.gtag) { try { gtag('event', 'festival_gift_tab_click'); } catch (err) {} } });
        }
        addChip(fe.dataset.gift, 'Diwali Hamper');
      }


      /* Festival welcome screen — every app launch, 5 s, tap to skip */
      if (cpLaunch && fe.dataset.intro === 'true') showIntro(); /* every app launch */
      function showIntro() {
        var NC = ['#f57c00', '#f3efe6', '#d32f2f', '#1e4fd8', '#f9c80e', '#2e9e48', '#8e8e8e', '#7b3fa0', '#00897b'];
        var GOLD = ['#ffd76a', '#e0a526', '#ffd76a', '#e0a526', '#ffd76a', '#e0a526', '#ffd76a', '#e0a526', '#ffd76a'];
        var SUN = ['#ff7043', '#ffca28', '#ff7043', '#ffca28', '#ff7043', '#ffca28', '#ff7043', '#ffca28', '#ff7043'];
        var T = {
          navratri: { title: 'Shubh Navratri', sub: 'Vrat-friendly atta, freshly milled for you', ring: NC, glow: '#ffb74d', offer: fe.dataset.offerNavratri, cta: 'Shop Now', link: '/', motif: 'dandiya' },
          dussehra: { title: 'Happy Dussehra', sub: 'Celebrate with fresh chakki atta', ring: SUN, glow: '#ffb74d', offer: '', cta: '', link: '', motif: 'diya' },
          diwali:   { title: 'Happy Diwali', sub: 'Gift the goodness of fresh chakki atta', ring: GOLD, glow: '#ffd76a', offer: fe.dataset.offerDiwali, cta: 'Shop Now', link: '/', motif: 'diya' },
          chhath:   { title: 'Chhath Puja ki Shubhkamnayein', sub: 'Pure, fresh & milled with care', ring: SUN, glow: '#ffca28', offer: '', cta: '', link: '', motif: 'diya' }
        }[fest];
        if (!T) return;
        var dayCol = (fest === 'navratri' && typeof c !== 'undefined') ? c : null;
        var tint = dayCol && dayCol[0] !== '#ffffff' ? dayCol[0] : T.glow;

        /* lotus of 9 petals around the logo (today's petal bigger) */
        var petals = '';
        for (var i = 0; i < 9; i++) {
          var ang = i * 40;
          var on = (dayCol && typeof dayIdx !== 'undefined' && i === Math.min(dayIdx, 8));
          petals += '<g transform="rotate(' + ang + ' 100 100)"><path d="M100 ' + (on ? 4 : 10) + ' C ' + (on ? 118 : 114) + ' 24, ' + (on ? 118 : 114) + ' 40, 100 52 C ' + (on ? 82 : 86) + ' 40, ' + (on ? 82 : 86) + ' 24, 100 ' + (on ? 4 : 10) + 'z" fill="' + T.ring[i] + '" stroke="#fff" stroke-width="' + (on ? 3 : 2) + '"/></g>';
        }
        /* rangoli / mandala behind */
        var mandala = '';
        for (var m = 0; m < 16; m++) {
          mandala += '<g transform="rotate(' + (m * 22.5) + ' 150 150)"><path d="M150 8 C162 40 162 60 150 78 C138 60 138 40 150 8z" fill="none" stroke="' + tint + '" stroke-width="1.4" opacity=".55"/><circle cx="150" cy="96" r="3" fill="' + tint + '" opacity=".5"/></g>';
        }
        /* marigold toran */
        var toran = '';
        for (var j = 0; j < 14; j++) {
          var tx = 14 + j * 28;
          toran += '<path d="M' + tx + ' 0 v10" stroke="#2e7d32" stroke-width="1.5"/>' +
                   '<circle cx="' + tx + '" cy="16" r="8.5" fill="' + (j % 2 ? '#ffb300' : '#f57c00') + '"/><circle cx="' + tx + '" cy="16" r="3.5" fill="' + (j % 2 ? '#ff8f00' : '#e65100') + '" opacity=".6"/>' +
                   '<path d="M' + tx + ' 24 c-6 6 -6 14 0 20 c6 -6 6 -14 0 -20z" fill="' + T.ring[j % 9] + '" stroke="#fff" stroke-width="1"/>';
        }
        /* falling marigold petals */
        var falls = '';
        for (var f = 0; f < 14; f++) {
          var left = Math.round(Math.random() * 100), delay = (Math.random() * 2.4).toFixed(2), dur = (3 + Math.random() * 2.5).toFixed(2), size = 7 + Math.round(Math.random() * 7);
          falls += '<i style="left:' + left + '%;width:' + size + 'px;height:' + Math.round(size * 1.4) + 'px;background:' + (f % 3 ? '#f57c00' : '#ffb300') + ';animation-delay:' + delay + 's;animation-duration:' + dur + 's"></i>';
        }
        /* motif under the title */
        var motif = T.motif === 'dandiya'
          ? '<svg class="cpintro__motif" viewBox="0 0 120 40" aria-hidden="true"><g stroke-linecap="round"><path d="M30 36 L90 4" stroke="#8a5a1c" stroke-width="5"/><path d="M30 4 L90 36" stroke="#8a5a1c" stroke-width="5"/><path d="M30 36 L44 28.5" stroke="' + NC[2] + '" stroke-width="5"/><path d="M90 4 L76 11.5" stroke="' + NC[3] + '" stroke-width="5"/><path d="M30 4 L44 11.5" stroke="' + NC[5] + '" stroke-width="5"/><path d="M90 36 L76 28.5" stroke="' + NC[0] + '" stroke-width="5"/></g><circle cx="60" cy="20" r="4" fill="#ffd76a" stroke="#8a5a1c" stroke-width="1.5"/></svg>'
          : '<svg class="cpintro__motif" viewBox="0 0 120 40" aria-hidden="true">' + [20, 60, 100].map(function (x) { return '<g transform="translate(' + (x - 13) + ',6)"><path class="flame" d="M13 3c2.6 3 3.4 5.2 3.4 6.7A3.4 3.4 0 0 1 13 13a3.4 3.4 0 0 1-3.4-3.3C9.6 8.2 10.4 6 13 3z" fill="#ffb300"/><path d="M3 14h20c-.8 4.6-4.9 8-10 8S3.8 18.6 3 14z" fill="#c4622d"/></g>'; }).join('') + '</svg>';

        var pill = dayCol ? '<span class="cpintro__pill"><i style="background:' + dayCol[0] + '"></i>Day ' + (dayIdx + 1) + ' · Today\'s colour: ' + dayCol[1] + '</span>' : '';
        var offer = T.offer ? '<div class="cpintro__offer">' + T.offer + '</div>' : '';
        var cta = (T.cta && T.link) ? '<a class="cpintro__cta" href="' + T.link + '">' + T.cta + ' →</a>' : '';

        var el = document.createElement('div');
        el.className = 'cpintro cpintro--' + fest;
        el.setAttribute('role', 'dialog');
        el.setAttribute('aria-label', T.title);
        el.style.setProperty('--cpi-tint', tint);
        el.innerHTML =
          /* first frame = same look as the splash (cream + logo), then it fades into the festive screen */
          '<div class="cpintro__start" aria-hidden="true"><img alt="" src="' + (fe.dataset.logo || '') + '"></div>' +
          '<div class="cpintro__falls" aria-hidden="true">' + falls + '</div>' +
          '<svg class="cpintro__toran" viewBox="0 0 392 46" preserveAspectRatio="xMidYMin slice" aria-hidden="true">' + toran + '</svg>' +
          '<div class="cpintro__mid">' +
            '<div class="cpintro__ring">' +
              '<div class="cpintro__rays" aria-hidden="true"></div>' +
              '<svg class="cpintro__mandala" viewBox="0 0 300 300" aria-hidden="true">' + mandala + '</svg>' +
              '<svg class="cpintro__lotus" viewBox="0 0 200 200" aria-hidden="true">' + petals + '</svg>' +
              '<div class="cpintro__logo"><img alt="Chakki Peesing" src="' + (fe.dataset.logo || '') + '" onerror="this.replaceWith(Object.assign(document.createElement(\'b\'),{textContent:\'Chakki Peesing\'}))"></div>' +
            '</div>' +
            '<h2 class="cpintro__title">' + T.title + '</h2>' + motif + pill +
            '<p class="cpintro__sub">' + T.sub + '</p>' + offer + cta +
          '</div>' +
          '<div class="cpintro__foot">Tap anywhere to continue</div>';
        document.body.appendChild(el);
        /* hand over from the head cover once the welcome screen has faded in (no flash of the page) */
        setTimeout(function () { document.documentElement.classList.remove('cp-cover'); }, 550);
        var gone = false;
        var close = function () {
          if (gone) return; gone = true;
          el.classList.add('is-out');
          setTimeout(function () { el.remove(); }, 500);
        };
        el.addEventListener('click', function (e) {
          if (e.target.closest && e.target.closest('.cpintro__cta')) {
            e.preventDefault(); /* "Shop Now" → straight into the homepage */
            if (window.gtag) { try { gtag('event', 'festival_intro_cta', { festival: fest }); } catch (err) {} }
          }
          close();
        });
        setTimeout(close, 5000); /* opens the homepage after 5 seconds */
        if (window.gtag) { try { gtag('event', 'festival_intro_view', { festival: fest }); } catch (err) {} }
      }

      function addChip(href, text) {
        var panel = document.getElementById('cpss');
        var row = panel && panel.querySelector('.cpss__group:not(.cpss__group--recent):not(.cpss__group--viewed) .cpss__chips');
        if (!row || !href) return;
        var a = document.createElement('a');
        a.className = 'cpss__chip cpss__chip--feature';
        a.href = href;
        a.textContent = text;
        row.insertBefore(a, row.firstChild);
      }
    })();

    /* 20) Everyday welcome screen — app opened on the homepage, no festival today.
       Real logo + one witty line that changes every day, chakki animation, 5 seconds, tap to skip. */
    (function () {
      var dd = document.getElementById('cpdaily');
      if (!dd || !cpLaunch || document.querySelector('.cpintro')) return;
      var lines = (dd.dataset.lines || '').split(/<br\s*\/?>|\n/i).map(function (l) { return l.trim(); }).filter(Boolean);
      if (!lines.length) return;
      /* same line all day, next line tomorrow */
      var now = new Date();
      var dayNo = Math.floor((now.getTime() - now.getTimezoneOffset() * 60000) / 86400000);
      var idx = dayNo % lines.length;
      var parts = lines[idx].split('|');
      var setup = (parts[0] || '').trim(), punch = (parts[1] || '').trim();
      if (!punch) { punch = setup; setup = ''; }
      var esc = function (t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; };

      /* falling grains + flour dust */
      var grains = '';
      for (var g = 0; g < 12; g++) {
        grains += '<i style="left:' + (38 + Math.random() * 24).toFixed(1) + '%;animation-delay:' + (Math.random() * 1.8).toFixed(2) + 's;animation-duration:' + (1.4 + Math.random() * .8).toFixed(2) + 's"></i>';
      }
      var dust = '';
      for (var u = 0; u < 10; u++) {
        var side = u % 2 ? 1 : -1;
        dust += '<b style="--dx:' + (side * (40 + Math.random() * 60)).toFixed(0) + 'px;--dy:' + (-10 - Math.random() * 40).toFixed(0) + 'px;animation-delay:' + (Math.random() * 2).toFixed(2) + 's"></b>';
      }
      /* chakki stone with grooves */
      var grooves = '';
      for (var k = 0; k < 12; k++) grooves += '<path d="M100 100 L' + (100 + 84 * Math.cos(k * Math.PI / 6)).toFixed(1) + ' ' + (100 + 84 * Math.sin(k * Math.PI / 6)).toFixed(1) + '" stroke="rgba(0,0,0,.12)" stroke-width="2"/>';

      var el = document.createElement('div');
      el.className = 'cpintro cpdaily';
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-label', 'Welcome');
      el.innerHTML =
        '<div class="cpintro__mid">' +
          '<div class="cpdaily__brand"><img alt="Chakki Peesing" src="' + (dd.dataset.logo || '') + '" onerror="this.replaceWith(Object.assign(document.createElement(\'b\'),{textContent:\'Chakki Peesing\'}))"></div>' +
          '<div class="cpdaily__chakki">' +
            '<div class="cpdaily__grains" aria-hidden="true">' + grains + '</div>' +
            '<svg class="cpdaily__stone" viewBox="0 0 200 200" aria-hidden="true"><defs><radialGradient id="cpst" cx="40%" cy="35%"><stop offset="0" stop-color="#cfc6b6"/><stop offset="1" stop-color="#8f8576"/></radialGradient></defs><circle cx="100" cy="100" r="92" fill="url(#cpst)"/><circle cx="100" cy="100" r="92" fill="none" stroke="rgba(0,0,0,.15)" stroke-width="3"/>' + grooves + '</svg>' +
            '<div class="cpdaily__dust" aria-hidden="true">' + dust + '</div>' +
            '<span class="cpdaily__hub" aria-hidden="true"></span>' +
          '</div>' +
          (setup ? '<p class="cpdaily__setup">' + esc(setup) + '</p>' : '') +
          '<h2 class="cpdaily__punch">' + esc(punch) + '</h2>' +
          '<div class="cpdaily__trust"><span>🌾 Milled after you order</span><span>🚫 No preservatives</span></div>' +
          '<a class="cpintro__cta" href="/">Shop Now →</a>' +
        '</div>' +
        '<div class="cpintro__foot">Tap anywhere to continue</div>';
      document.body.appendChild(el);
      setTimeout(function () { document.documentElement.classList.remove('cp-cover'); }, 550);
      var gone = false;
      var close = function () {
        if (gone) return; gone = true;
        el.classList.add('is-out');
        setTimeout(function () { el.remove(); }, 500);
      };
      el.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.cpintro__cta')) {
          e.preventDefault();
          if (window.gtag) { try { gtag('event', 'daily_intro_cta', { line: idx }); } catch (err) {} }
        }
        close();
      });
      setTimeout(close, 5000);
      if (window.gtag) { try { gtag('event', 'daily_intro_view', { line: idx }); } catch (err) {} }
    })();

    /* 1) Search → open the header search popup (fallback: /search page) */
    /* The theme has 2 search popups (desktop + mobile) — use the one that is visible on screen */
    function visibleSearch() {
      var all = document.querySelectorAll('details-modal.header__search');
      for (var i = 0; i < all.length; i++) {
        /* popup element is visible (works even when the icon is hidden) */
        if (all[i].getClientRects().length) return all[i];
      }
      return null;
    }
    function openSearch(e) {
      var dm = visibleSearch();
      if (!dm) return null; /* no visible popup → the link falls through to the /search page */
      e.preventDefault();
      e.stopPropagation(); /* required: otherwise the theme's body-click handler closes the popup immediately */
      var det = dm.querySelector('details');
      if (!det || !det.hasAttribute('open')) dm.querySelector('summary').click();
      var inp = dm.querySelector('input[type="search"]');
      if (inp) inp.focus();
      return dm;
    }
    nav.querySelectorAll('[data-cpbn="search"]').forEach(function (a) {
      a.addEventListener('click', openSearch);
    });

    /* 1b) Search bar → move it below the header + open the search popup on tap */
    var sb = document.getElementById('cpsb');
    if (sb) {
      var hdr = document.querySelector('.section-header') || document.querySelector('[id^="shopify-section"][id*="header"]');
      if (hdr && hdr.parentNode) hdr.parentNode.insertBefore(sb, hdr.nextSibling);
      sb.querySelector('.cpsb__box').addEventListener('click', function (e) {
        var dm = openSearch(e);
        var qEl = sb.querySelector('[data-q]');
        if (dm && qEl) {
          var qi = dm.querySelector('input[type="search"]');
          if (qi && !qi.value) {
            /* search-precision puts the customer's own words in ?oq= — never show the search syntax */
            var oqv = null;
            try { oqv = new URLSearchParams(location.search).get('oq'); } catch (err) {}
            qi.value = oqv || qEl.getAttribute('data-q');
            qi.dispatchEvent(new Event('input', { bubbles: true }));
            try { qi.select(); } catch (err) {}
          }
        }
      });

      var w = sb.querySelector('.cpsb__word');
      var words = (w && w.dataset.words || '').split('|').map(function (x) { return x.trim(); }).filter(Boolean);
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (w && words.length > 1 && !reduce) {
        var wi = 0;
        setInterval(function () {
          if (document.hidden || sb.classList.contains('is-listening') || sb.dataset.msg) return;
          w.classList.add('is-out');
          setTimeout(function () {
            wi = (wi + 1) % words.length;
            w.textContent = words[wi];
            w.classList.remove('is-out');
          }, 250);
        }, 2500);
      }

      /* 1b-2) Scrolled past the bar → a small search pill takes the logo's place in the sticky header */
      (function () {
        var head = document.querySelector('.section-header');
        var hdrEl = head && head.querySelector('.header');
        if (!hdrEl || design) return;
        var mini = document.createElement('button');
        mini.type = 'button';
        mini.className = 'cpsb-mini';
        mini.setAttribute('aria-label', 'Search products');
        mini.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg><span></span>';
        hdrEl.appendChild(mini);
        var miniText = mini.querySelector('span');
        var srcText = sb.querySelector('.cpsb__text');
        var syncText = function () {
          if (!srcText) return;
          var wEl = srcText.querySelector('.cpsb__word');
          var lead = srcText.firstChild && srcText.firstChild.nodeType === 3 ? srcText.firstChild.textContent : '';
          miniText.innerHTML = '';
          miniText.appendChild(document.createTextNode(lead));
          var b = document.createElement('b'); b.textContent = wEl ? wEl.textContent : ''; miniText.appendChild(b);
        };
        syncText();
        if (srcText && window.MutationObserver) new MutationObserver(syncText).observe(srcText, { childList: true, subtree: true, characterData: true });
        /* keep clear of the menu button (left) and the header icons (right) */
        var place = function () {
          var hr = hdrEl.getBoundingClientRect();
          var drawer = hdrEl.querySelector('header-drawer');
          var icons = hdrEl.querySelector('.header__icons');
          var l = drawer ? drawer.getBoundingClientRect().right - hr.left + 6 : 56;
          var minL = hr.right;
          if (icons) icons.querySelectorAll('a, button, summary').forEach(function (el) {
            var rc = el.getBoundingClientRect();
            if (rc.width && rc.height && rc.left < minL) minL = rc.left;
          });
          var r = hr.right - minL + 6;
          mini.style.left = Math.max(l, 44) + 'px';
          mini.style.right = Math.max(r, 44) + 'px';
        };
        var docked = false, ticking = false;
        var check = function () {
          ticking = false;
          if (!mq.matches) { if (docked) { docked = false; document.documentElement.classList.remove('cpsb-docked'); } return; }
          var on = sb.getBoundingClientRect().bottom <= head.getBoundingClientRect().bottom + 2;
          if (on !== docked) {
            docked = on;
            if (on) place();
            document.documentElement.classList.toggle('cpsb-docked', on);
          }
        };
        window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
        window.addEventListener('resize', function () { if (docked) place(); });
        check();
        mini.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          sb.querySelector('.cpsb__box').click();
          if (window.gtag) { try { gtag('event', 'search_header_pill'); } catch (err) {} }
        });
      })();

      /* 1c) Voice search — Chrome (Android) + Safari (iOS 14.5+) */
      var mic = sb.querySelector('.cpsb__mic');
      var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
      if (mic) {
        mic.hidden = false;
        sb.classList.add('has-mic');
        var txt = sb.querySelector('.cpsb__text');
        var original = txt.innerHTML;
        var rec = null, gotResult = false, msgTimer;

        function say(text, isError, keepMs) {
          clearTimeout(msgTimer);
          sb.dataset.msg = '1';
          txt.innerHTML = '';
          var m = document.createElement('span');
          m.className = 'cpsb__msg' + (isError ? ' is-error' : '');
          m.textContent = text;
          txt.appendChild(m);
          if (keepMs) msgTimer = setTimeout(reset, keepMs);
        }
        function reset() {
          clearTimeout(msgTimer);
          delete sb.dataset.msg;
          sb.classList.remove('is-listening');
          txt.innerHTML = original;
          w = sb.querySelector('.cpsb__word');
        }
        function stop() { try { rec && rec.abort(); } catch (err) {} }

        mic.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (sb.classList.contains('is-listening')) { stop(); reset(); return; }

          /* Browser has no voice support (iPhone Chrome, Samsung Internet, in-app browsers):
             open the search popup — customers can use the keyboard mic instead */
          if (!SR) {
            var vdm = openSearch(e);
            if (!vdm) { window.location.href = mic.dataset.searchUrl || '/search'; return; }
            var si = vdm.querySelector('input[type="search"]');
            if (si) {
              var ph = si.getAttribute('placeholder');
              si.setAttribute('placeholder', 'Tap the 🎤 on your keyboard to speak');
              setTimeout(function () { if (ph !== null) si.setAttribute('placeholder', ph); else si.removeAttribute('placeholder'); }, 6000);
            }
            return;
          }

          rec = new SR();
          rec.lang = 'en-IN';
          rec.interimResults = true;
          rec.maxAlternatives = 1;
          rec.continuous = false;
          gotResult = false;

          rec.onstart = function () {
            sb.classList.add('is-listening');
            say('Listening… say "multigrain atta"');
          };
          rec.onresult = function (ev) {
            var t = '', final = false;
            for (var i = ev.resultIndex; i < ev.results.length; i++) {
              t += ev.results[i][0].transcript;
              if (ev.results[i].isFinal) final = true;
            }
            t = t.trim();
            if (!t) return;
            say('"' + t + '"');
            if (final) {
              gotResult = true;
              sb.classList.remove('is-listening');
              var url = (mic.dataset.searchUrl || '/search') + '?q=' + encodeURIComponent(t) + '&type=product&options%5Bprefix%5D=last';
              if (window.gtag) { try { gtag('event', 'search', { search_term: t, method: 'voice' }); } catch (err) {} }
              if (window.fbq) { try { fbq('track', 'Search', { search_string: t }); } catch (err) {} }
              setTimeout(function () { window.location.href = url; }, 350);
            }
          };
          rec.onerror = function (ev) {
            gotResult = true;
            sb.classList.remove('is-listening');
            if (ev.error === 'not-allowed' || ev.error === 'service-not-allowed') {
              say('Allow microphone access to search by voice', true, 3500);
            } else if (ev.error === 'no-speech') {
              say("Didn't catch that — tap the mic and try again", true, 3000);
            } else if (ev.error !== 'aborted') {
              say('Voice search unavailable, please type instead', true, 3000);
            }
          };
          rec.onend = function () {
            sb.classList.remove('is-listening');
            if (!gotResult) say("Didn't catch that — tap the mic and try again", true, 3000);
          };

          try { rec.start(); } catch (err) { say('Voice search unavailable, please type instead', true, 3000); }
        });

        window.addEventListener('pagehide', stop);
      }
    }

    /* 1d) Search popup: popular + recent searches chips */
    var RKEY = 'cp_recent_searches';
    function getRecent() {
      try { var a = JSON.parse(localStorage.getItem(RKEY) || '[]'); return Array.isArray(a) ? a : []; } catch (err) { return []; }
    }
    function saveRecent(q) {
      q = String(q || '').replace(/\s+/g, ' ').trim();
      if (!q || q.length > 60) return;
      var a = getRecent().filter(function (x) { return String(x).toLowerCase() !== q.toLowerCase(); });
      a.unshift(q);
      try { localStorage.setItem(RKEY, JSON.stringify(a.slice(0, 6))); } catch (err) {}
    }
    /* On the search results page → save the query to recent searches (typed, chip or voice) */
    if (/\/search\/?$/.test(location.pathname)) {
      try {
        var sp = new URLSearchParams(location.search);
        var cq = sp.get('oq') || sp.get('q');
        if (cq && !/\b(title|product_type|tag|vendor):/i.test(cq)) saveRecent(cq);
        /* show the customer's own words (not the search syntax) in the bar and the WhatsApp message */
        var oq0 = sp.get('oq');
        if (oq0) {
          var bw = document.querySelector('#cpsb .cpsb__text[data-q]');
          if (bw) { bw.setAttribute('data-q', oq0); var bww = bw.querySelector('.cpsb__word'); if (bww) bww.textContent = oq0; }
          var wa = document.querySelector('#cpwa-search .cpwa__btn');
          if (wa) { var wu = new URL(wa.href); wu.searchParams.set('text', "Hi Chakki Peesing, I'm looking for: " + oq0); wa.href = wu.toString(); }
        }
      } catch (err) {}
    }

    var ss = document.getElementById('cpss');
    var searchModals = document.querySelectorAll('details-modal.header__search');
    if (ss && searchModals.length) {
      var sBase = ss.dataset.searchUrl || '/search';
      var clockSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg>';
      var cur = null; /* popup that currently holds the chips */

      function renderRecent() {
        var a = getRecent();
        var wrap = ss.querySelector('.cpss__chips--recent');
        var grp = ss.querySelector('.cpss__group--recent');
        wrap.innerHTML = '';
        a.forEach(function (q) {
          var c = document.createElement('a');
          c.className = 'cpss__chip cpss__chip--recent';
          c.href = sBase + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last';
          c.innerHTML = clockSvg;
          c.appendChild(document.createTextNode(q));
          wrap.appendChild(c);
        });
        grp.hidden = !a.length;
      }
      /* WhatsApp help inside the popup when a typed search finds nothing */
      var waNum = ss.dataset.wa || '';
      var emptyBox = null, emptyTimer = null, emptyQ = '';
      function attachEmpty(dm, host) {
        if (!waNum) return;
        if (!emptyBox) {
          emptyBox = document.createElement('div');
          emptyBox.className = 'cpss-empty';
          emptyBox.hidden = true;
        }
        host.appendChild(emptyBox);
      }
      function checkEmpty(inp) {
        if (!waNum || !emptyBox) return;
        var q = (inp.value || '').trim();
        clearTimeout(emptyTimer);
        if (q.length < 3) { emptyBox.hidden = true; return; }
        emptyTimer = setTimeout(function () {
          emptyQ = q;
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=1', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (d) {
              if (emptyQ !== q) return;
              var n = (d && d.resources && d.resources.results && d.resources.results.products || []).length;
              if (n) { emptyBox.hidden = true; return; }
              var msg = 'Hi Chakki Peesing, I\'m looking for: ' + q;
              emptyBox.innerHTML = '<div class="cpwa cpwa--empty"><strong class="cpwa__title"></strong><span class="cpwa__text">Tell us what you need on WhatsApp and we\'ll help you find it.</span><a class="cpwa__btn" target="_blank" rel="noopener"><svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2c-1.6 0-3.1-.4-4.4-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.3-.4.2-.4.7-1.4.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.7 11.8 11.8 0 0 0 4.5 4c1.7.7 2.3.8 3.2.6.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2-.1-.1-.2-.2-.4-.3z"/></svg> Ask us on WhatsApp</a></div>';
              emptyBox.querySelector('.cpwa__title').textContent = 'No match for “' + q + '”';
              emptyBox.querySelector('.cpwa__btn').href = 'https://wa.me/' + waNum + '?text=' + encodeURIComponent(msg);
              emptyBox.hidden = false;
              if (window.gtag) { try { gtag('event', 'search_no_results', { search_term: q }); } catch (err) {} }
            })
            .catch(function () {});
        }, 600);
      }

      function syncChips() {
        if (!cur) return;
        var inp = cur.querySelector('input[type="search"]');
        var on = !(inp && inp.value.trim());
        ss.classList.toggle('is-hidden', !on);
        var m = cur.querySelector('.search-modal');
        if (m) m.classList.toggle('cpss-active', on);
      }
      function attachTo(dm) {
        var host = dm.querySelector('predictive-search') || dm.querySelector('form[action*="/search"]');
        if (!host) return;
        if (cur && cur !== dm) {
          var oldM = cur.querySelector('.search-modal');
          if (oldM) oldM.classList.remove('cpss-active');
        }
        cur = dm;
        host.appendChild(ss);
        ss.hidden = false;
        if (window.__cpRenderViewed) window.__cpRenderViewed(ss);
        attachEmpty(dm, host);
        renderRecent();
        syncChips();
      }

      Array.prototype.forEach.call(searchModals, function (dm) {
        var det = dm.querySelector('details');
        var inp = dm.querySelector('input[type="search"]');
        var form = dm.querySelector('form');
        if (det) det.addEventListener('toggle', function () { if (det.open) attachTo(dm); });
        if (inp) inp.addEventListener('input', function () { if (cur === dm) { syncChips(); checkEmpty(inp); } });
        if (form) {
          form.addEventListener('reset', function () { setTimeout(syncChips, 0); });
          form.addEventListener('submit', function () { if (inp) saveRecent(inp.value); });
        }
      });
      /* Insert chips only when the popup opens — inserting on page load breaks the theme's ✕ (close) button */

      ss.querySelector('.cpss__clear').addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        try { localStorage.removeItem(RKEY); } catch (err) {}
        renderRecent();
      });
    }

    /* 1e) Account → use KwikPass (GoKwik OTP login) like the header account icon does.
       KwikPass only binds to /account links that exist when its script runs, and this
       section loads later, so the tab would otherwise open Shopify's own login page. */
    nav.querySelectorAll('[data-cpbn="account"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (typeof window.kpHandleLogin === 'function') {
          e.preventDefault();
          e.stopPropagation();
          window.kpHandleLogin('/account');
          return;
        }
        var h = document.querySelector('header a[href="/account"], header .header__icon--account, header .header__icon--accounts');
        if (h && h !== a) {
          e.preventDefault();
          e.stopPropagation();
          h.click();
        }
      });
    });

    /* 2) Cart → click the header cart icon (opens the GoKwik side cart; fallback: /cart) */
    nav.querySelectorAll('[data-cpbn="cart"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var h = document.getElementById('cart-icon-bubble');
        if (!h) return;
        e.preventDefault();
        e.stopPropagation();
        h.click();
      });
    });

    /* 3) Live cart count */
    var badges = nav.querySelectorAll('.cpbn__count');
    var last = null;
    function setCount(n) {
      n = parseInt(n, 10) || 0;
      badges.forEach(function (b) {
        b.textContent = n > 99 ? '99+' : n;
        b.hidden = n === 0;
        if (last !== null && n > last) {
          b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump');
        }
      });
      last = n;
    }
    if (badges.length) setCount(badges[0].textContent);

    function refresh() {
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          /* MYOM stores its price as quantity → count each MYOM line as 1 */
          var n = (c.items || []).reduce(function (sum, it) {
            return sum + (it.handle === 'make-your-own-mix' ? 1 : (it.quantity || 0));
          }, 0);
          setCount(c.items ? n : c.item_count);
        })
        .catch(function () {});
    }
    var t;
    function later() { clearTimeout(t); t = setTimeout(refresh, 350); }
    var rx = /\/cart\/(add|change|update|clear)/;

    /* Patch fetch/XHR only once per page, and never inside the theme editor */
    var doPatch = !design && !window.__cpbnPatched;
    if (doPatch) window.__cpbnPatched = true;
    if (doPatch && window.fetch) {
      var of = window.fetch;
      window.fetch = function (input) {
        var url = (input && input.url) || String(input || '');
        var p = of.apply(this, arguments);
        if (rx.test(url)) p.then(later, later);
        return p;
      };
    }
    if (doPatch) {
      var oo = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (m, url) {
        if (rx.test(String(url || ''))) this.addEventListener('loadend', later);
        return oo.apply(this, arguments);
      };
    }
    ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function (ev) {
      document.addEventListener(ev, later);
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) later(); });

    var hb = document.getElementById('cart-icon-bubble');
    if (hb && 'MutationObserver' in window) {
      new MutationObserver(later).observe(hb, { childList: true, subtree: true, characterData: true });
    }

    var chatApply = null;
    /* 4) Lift the Verifast chat bubble above the nav (leave it full-screen when the chat is open) */
    function fixChat() {
      var f = document.getElementById('verifast-react-chatbot-iframe');
      if (!f) return false;
      function apply() {
        if (mq.matches && f.offsetHeight > 0 && f.offsetHeight < 160) {
          var card = document.getElementById('cpro');
          var extra = (card && !card.hidden && document.body.classList.contains('cpro-on')) ? card.offsetHeight + 32 : 0;
          f.style.setProperty('bottom', 'calc(' + (74 + extra) + 'px + env(safe-area-inset-bottom))', 'important');
        } else {
          f.style.removeProperty('bottom');
        }
      }
      apply();
      chatApply = apply;
      if ('ResizeObserver' in window) new ResizeObserver(apply).observe(f);
      mq.addEventListener && mq.addEventListener('change', apply);
      return true;
    }
    if (!fixChat() && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () { if (fixChat()) mo.disconnect(); });
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 20000);
    }

    /* 5) Reorder card — add the last order to the cart in one tap */
    var ro = document.getElementById('cpro');
    if (ro) {
      var RO_KEY = 'cp_reorder_dismissed';
      var oid = ro.dataset.order;
      var dis = null;
      try { dis = localStorage.getItem(RO_KEY); } catch (err) {}
      function showRo() { ro.hidden = false; document.body.classList.add('cpro-on'); if (chatApply) chatApply(); }
      function hideRo() { ro.hidden = true; document.body.classList.remove('cpro-on'); if (chatApply) chatApply(); }
      function remember() { try { localStorage.setItem(RO_KEY, oid); } catch (err) {} }
      var roDue = ro.dataset.due === 'true';
      /* homepage only; ✕ hides it until the customer places a new order */
      if (!design && location.pathname === '/' && dis !== oid) { /* keep the editor preview clear */
        if (isApp || roDue) showRo();
      }

      ro.querySelector('.cpro__x').addEventListener('click', function (e) {
        e.preventDefault();
        remember();
        hideRo();
      });

      var roBtn = ro.querySelector('.cpro__btn');
      var roDone = false;
      function openCart() {
        var h = document.getElementById('cart-icon-bubble');
        if (h) h.click(); else window.location.href = '/cart';
      }
      function post(body) {
        return fetch('/cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });
      }
      roBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (roDone) { openCart(); return; }
        var items = [];
        try { items = JSON.parse(ro.querySelector('.cpro__data').textContent) || []; } catch (err) {}
        /* props [[key, value], ...] → properties { key: value } */
        items = items.map(function (it) {
          var o = { id: it.id, quantity: it.quantity };
          if (it.props && it.props.length) {
            o.properties = {};
            it.props.forEach(function (kv) { o.properties[kv[0]] = kv[1]; });
          }
          return o;
        });
        if (!items.length) return;
        roBtn.disabled = true;
        roBtn.textContent = 'Adding…';

        post({ items: items })
          .then(function () { return items.length; })
          .catch(function () {
            /* if an item is out of stock, add the rest one by one */
            return items.reduce(function (p, it) {
              return p.then(function (n) {
                return post({ items: [it] }).then(function () { return n + 1; }, function () { return n; });
              });
            }, Promise.resolve(0));
          })
          .then(function (n) {
            if (!n) throw new Error('none added');
            roDone = true;
            remember();
            roBtn.disabled = false;
            roBtn.classList.add('is-done');
            roBtn.textContent = 'View cart →';
            ro.querySelector('.cpro__info strong').textContent = n < items.length ? (n + ' of ' + items.length + ' added ✓') : 'Added to cart ✓';
            if (window.gtag) { try { gtag('event', 'reorder', { items: n }); } catch (err) {} }
            if (window.fbq) { try { fbq('trackCustom', 'Reorder', { items: n }); } catch (err) {} }
            setTimeout(function () { if (!ro.hidden) hideRo(); }, 8000);
          })
          .catch(function () {
            roBtn.disabled = false;
            roBtn.textContent = 'Try again';
          });
      });
    }

    /* 14) "Welcome back" bar — home screen app only, once per app session */
    var wb = document.getElementById('cpwb');
    if (wb && isApp && !design) {
      var seen = null;
      try { seen = sessionStorage.getItem('cp_wb_seen'); } catch (err) {}
      if (!seen) {
        try { sessionStorage.setItem('cp_wb_seen', '1'); } catch (err) {}
        var hdrW = document.querySelector('.section-header');
        if (hdrW && hdrW.parentNode) hdrW.parentNode.insertBefore(wb, hdrW.nextSibling);
        var roCard = document.getElementById('cpro');
        var rBtn = wb.querySelector('[data-act="reorder"]');
        var sBtn = wb.querySelector('[data-act="shop"]');
        var lBtn0 = wb.querySelector('[data-act="login"]');
        /* KwikPass (GoKwik OTP) login keeps its own token — treat that as logged in too */
        var kpLoggedIn = function () {
          try {
            var env = window.merchantInfo && window.merchantInfo.environment;
            var k = typeof window.XGokwikCoreToken === 'function' ? window.XGokwikCoreToken(env) : null;
            if (!k) return false;
            var v = (typeof window.kpGetCookieValue === 'function' && window.kpGetCookieValue(k)) ||
                    (typeof window.kpGetLocalStorageValue === 'function' && window.kpGetLocalStorageValue(k));
            return !!v;
          } catch (err) { return false; }
        };
        var pickAction = function () {
          if (rBtn && roCard) { rBtn.hidden = false; if (sBtn) sBtn.hidden = true; if (lBtn0) lBtn0.hidden = true; return; }
          if (lBtn0 && !kpLoggedIn()) { lBtn0.hidden = false; if (sBtn) sBtn.hidden = true; return; }
          if (lBtn0) lBtn0.hidden = true;
          if (sBtn) sBtn.hidden = false;
        };
        pickAction();
        /* KwikPass loads a bit later — check again once it is ready */
        setTimeout(pickAction, 1500);
        setTimeout(pickAction, 4000);
        wb.hidden = false;
        if (rBtn) rBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var b = roCard && roCard.querySelector('.cpro__btn');
          if (b) { if (roCard.hidden) { roCard.hidden = false; document.body.classList.add('cpro-on'); } b.click(); }
          wb.hidden = true;
          if (window.gtag) { try { gtag('event', 'welcome_reorder_click'); } catch (err) {} }
        });
        var lBtn = wb.querySelector('[data-act="login"]');
        if (lBtn) lBtn.addEventListener('click', function (e) {
          if (typeof window.kpHandleLogin === 'function') { e.preventDefault(); window.kpHandleLogin('/account'); }
        });
        wb.querySelector('.cpwb__x').addEventListener('click', function (e) { e.preventDefault(); wb.hidden = true; });
      }
    }

    /* 16) App-mode polish: back button, loading line, resume where you left off, haptics */
    (function () {
      var cfg = document.getElementById('cpappcfg');
      if (!cfg || design) return;
      var path = location.pathname;

      /* 16b) Back button in the header (app mode has no browser back button on iPhone) */
      if (isApp && cfg.dataset.back === 'true' && path !== '/') {
        var hdrB = document.querySelector('.section-header .header') || document.querySelector('.section-header');
        if (hdrB) {
          var back = document.createElement('button');
          back.type = 'button';
          back.className = 'cpback';
          back.setAttribute('aria-label', 'Go back');
          back.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
          if (getComputedStyle(hdrB).position === 'static') hdrB.style.position = 'relative';
          hdrB.appendChild(back);
          back.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (window.history.length > 1 && document.referrer && document.referrer.indexOf(location.host) !== -1) history.back();
            else location.href = '/';
          });
        }
      }

      /* 16c) Loading line while the next page opens (app mode) */
      if (isApp && cfg.dataset.loading === 'true') {
        var bar = document.createElement('div');
        bar.className = 'cpload';
        document.body.appendChild(bar);
        var startBar = function () { bar.classList.remove('is-on'); void bar.offsetWidth; bar.classList.add('is-on'); };
        var stopBar = function () { bar.classList.remove('is-on'); };
        document.addEventListener('click', function (e) {
          var a = e.target.closest && e.target.closest('a[href]');
          if (!a) return;
          setTimeout(function () {
            if (e.defaultPrevented || a.target === '_blank' || a.hasAttribute('download') || e.metaKey || e.ctrlKey) return;
            var href = a.getAttribute('href') || '';
            if (!href || href.charAt(0) === '#' || href.indexOf('javascript:') === 0 || href.indexOf('tel:') === 0 || href.indexOf('mailto:') === 0) return;
            try { var u = new URL(a.href, location.href); if (u.origin !== location.origin) return; if (u.pathname === location.pathname && u.search === location.search && u.hash) return; } catch (err) { return; }
            startBar();
          }, 0);
        });
        document.addEventListener('submit', function (e) { setTimeout(function () { if (!e.defaultPrevented) startBar(); }, 0); });
        window.addEventListener('pageshow', stopBar);
      }

      /* 16d) Light vibration on key taps (Android; iPhone ignores it) */
      var hp = cfg.dataset.haptics || 'app';
      if (navigator.vibrate && (hp === 'all' || (hp === 'app' && isApp))) {
        var HSEL = '.cpbn__item, .cpbn__mix, .cpro__btn, .cpwb__act, .cpsb__mic, .cptrack__link, .cpss__chip, ' +
                   'button[name="add"], .product-form__submit, [data-add-to-cart], .quick-add__submit';
        document.addEventListener('click', function (e) {
          var t = e.target.closest && e.target.closest('button, a');
          if (!t) return;
          var txt = (t.textContent || '').toLowerCase();
          if (t.matches(HSEL) || /add to cart|buy now|reorder/.test(txt)) {
            try { navigator.vibrate(12); } catch (err) {}
          }
        }, true);
      }
    })();

    /* 15) iPhone splash screen — draw it on the phone at the exact screen size, so iOS
       shows a cream screen with the logo when the home screen icon is opened */
    (function () {
      var sp = document.getElementById('cpsplash');
      var ua2 = navigator.userAgent || '';
      var ios = /iPhone|iPad|iPod/.test(ua2) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      if (!sp || !ios || isApp || design || !sp.dataset.logo) return;
      if (cpWelcomeOn) sp.dataset.plain = '1';
      var run = function () {
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () {
          try {
            var dpr = window.devicePixelRatio || 1;
            var w = Math.round(screen.width * dpr), h = Math.round(screen.height * dpr);
            var c = document.createElement('canvas');
            c.width = w; c.height = h;
            var x = c.getContext('2d');
            x.fillStyle = '#f5ead5'; x.fillRect(0, 0, w, h);
            if (!sp.dataset.plain) { /* plain cream when a welcome screen follows (no double logo) */
              var lw = w * 0.62, lh = lw * (img.naturalHeight / img.naturalWidth);
              x.drawImage(img, (w - lw) / 2, h * 0.42 - lh / 2, lw, lh);
              var tag = sp.dataset.tagline || '';
              if (tag) {
                x.fillStyle = '#033e31';
                x.font = '600 ' + Math.round(16 * dpr) + 'px Montserrat, -apple-system, sans-serif';
                x.textAlign = 'center';
                x.fillText(tag, w / 2, h * 0.42 + lh / 2 + 34 * dpr);
              }
            }
            var link = document.createElement('link');
            link.rel = 'apple-touch-startup-image';
            link.href = c.toDataURL('image/png');
            document.head.appendChild(link);
          } catch (err) {}
        };
        img.src = sp.dataset.logo;
      };
      if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 4000 }); else setTimeout(run, 2500);
    })();

    /* 6) Add to Home Screen — card from the 3rd visit (Android: install popup, iPhone: steps) */
    (function () {
      var card = document.getElementById('cpa2hs');
      if (design) return; /* no install card inside the theme editor */
      var VKEY = 'cp_pwa_visits', DKEY = 'cp_pwa_dismissed', IKEY = 'cp_pwa_installed';
      function lsGet(k) { try { return localStorage.getItem(k); } catch (err) { return null; } }
      function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (err) {} }
      var standalone = (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || window.navigator.standalone === true;

      /* Opened from the home screen app → send to GA4 once per session */
      if (standalone) {
        try {
          if (!sessionStorage.getItem('cp_app_open')) {
            sessionStorage.setItem('cp_app_open', '1');
            if (window.gtag) gtag('event', 'app_open');
          }
        } catch (err) {}
        return;
      }

      /* Visit count — one session = one visit */
      var visits = parseInt(lsGet(VKEY) || '0', 10) || 0;
      try {
        if (!sessionStorage.getItem('cp_pwa_counted')) {
          sessionStorage.setItem('cp_pwa_counted', '1');
          visits += 1;
          lsSet(VKEY, String(visits));
        }
      } catch (err) {}

      window.addEventListener('appinstalled', function () {
        lsSet(IKEY, '1');
        if (card) card.hidden = true;
        if (window.gtag) { try { gtag('event', 'app_installed'); } catch (err) {} }
        if (window.fbq) { try { fbq('trackCustom', 'AppInstalled'); } catch (err) {} }
      });

      if (!card || !mq.matches) return;
      var ua = navigator.userAgent || '';
      var isIOS = /iPhone|iPad|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      /* In-app browsers (Google app, Instagram, Facebook…) can't add to the home screen */
      var inApp = /Instagram|FBAN|FBAV|FB_IAB|Line\/|; wv\)|Snapchat|LinkedInApp|GSA\/|Pinterest|Twitter/i.test(ua);
        var need = 1; /* On Every Visit */
      var dis = parseInt(lsGet(DKEY) || '0', 10) || 0;
            if (inApp || lsGet(IKEY) || visits < need || (dis && Date.now() - dis < 30 * 60000)) return;
      if (isIOS && card.dataset.ios === 'false') return; /* Customizer: hide the card on iPhone */
      var iosChrome = /CriOS|EdgiOS|FxiOS/.test(ua);

      var isTop = card.classList.contains('cpa2hs--top');
      var btn = card.querySelector('.cpa2hs__btn');
      var btnLabel = btn.textContent;
      var steps = card.querySelector('.cpa2hs__steps');
      var text = card.querySelector('.cpa2hs__text');
      var shareSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 15V3"/><path d="m7 8 5-5 5 5"/><path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7"/></svg>';
      var dotsSvg = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="12" cy="5" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="12" cy="19" r="2"/></svg>';

      function showSteps() {
        text.hidden = true;
        steps.hidden = false;
        var moreSvg = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></svg>';
        steps.innerHTML = !isIOS
          ? '1. Tap ' + dotsSvg + ' <b>menu</b> at the top<br>2. Choose <b>Add to Home screen</b> / <b>Install app</b>'
          : iosChrome
            ? '1. Tap ' + shareSvg + ' <b>Share</b> (top right)<br>2. Tap <b>Add to Home Screen</b> ⊞<br><small>Not there? Open this page in Safari.</small>'
            : '1. Tap ' + moreSvg + ' (bottom right) → ' + shareSvg + ' <b>Share</b><br>2. Tap <b>View More</b> / scroll down → <b>Add to Home Screen</b> ⊞<br><small>Not there? You may be inside WhatsApp or Instagram — open this page in Safari.</small>';
        btn.textContent = 'Got it';
        btn.dataset.mode = 'done';
      }
      function close(remember) {
        card.hidden = true;
        if (remember) lsSet(DKEY, String(Date.now()));
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.dataset.mode === 'done') { close(true); return; }
        var ev = window.__cpInstall;
        if (ev && ev.prompt) {
          ev.prompt();
          if (window.gtag) { try { gtag('event', 'app_install_prompt'); } catch (err) {} }
          (ev.userChoice || Promise.resolve({})).then(function (c) {
            window.__cpInstall = null;
            if (c && c.outcome === 'accepted') { lsSet(IKEY, '1'); card.hidden = true; }
            else if (isTop) { btn.textContent = btnLabel; } /* keep the top bar; ✕ closes it */
            else close(true);
          });
        } else {
          showSteps();
        }
      });
      if (isTop) {
        /* Top bar: sits at the very top of the page, above the header */
        document.body.insertBefore(card, document.body.firstChild);
        try { if (sessionStorage.getItem('cp_pwa_shown')) return; sessionStorage.setItem('cp_pwa_shown', '1'); } catch (err) {}
        card.hidden = false;
        if (window.gtag) { try { gtag('event', 'app_install_card_shown', { style: 'top' }); } catch (err) {} }
      }
      card.querySelector('.cpa2hs__later').addEventListener('click', function (e) {
        e.preventDefault();
        close(true);
      });

      /* Skip this visit if the Reorder card is showing (both use the same spot) */
      if (!isTop) setTimeout(function () {
        if (document.body.classList.contains('cpro-on')) return;
        if (document.body.classList.contains('overflow-hidden')) return;
        try { if (sessionStorage.getItem('cp_pwa_shown')) return; sessionStorage.setItem('cp_pwa_shown', '1'); } catch (err) {}
        card.hidden = false;
        if (window.gtag) { try { gtag('event', 'app_install_card_shown'); } catch (err) {} }
      }, 3500);
    })();
  })();

  /* No festival welcome screen this time → drop the head cover right away */
  if (!document.querySelector('.cpintro')) document.documentElement.classList.remove('cp-cover');
  }
  cpInit();
  /* Theme editor: re-run when the section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#cpbn')) cpInit();
  });
})();
